<div class="flex">
  <label [style.background-color]="color" class="theme-picker cursor-pointer">
    <input (ngModelChange)="onColorChange()" [(ngModel)]="color" [disabled]="disabled" type="color">
  </label>
  <input
    *ngIf="!showClear"
    [(ngModel)]="color"
    [placeholder]="'common.default' | transloco"
    [class.uppercase]="color"
    (ngModelChange)="onColorChange()"
    [disabled]="disabled"
    pInputText
    class="flex-grow-1 uppercase sm:min-w-0 sm:w-auto w-full"
  >
  <span *ngIf="showClear" class="p-input-icon-right flex flex-grow-1">
    <input
      [(ngModel)]="color"
      [placeholder]="'common.default' | transloco"
      [class.uppercase]="color"
      (ngModelChange)="onColorChange()"
      [disabled]="disabled"
      pInputText
      class="sm:w-auto w-full flex-grow-1"
    >
    <i (click)="color = undefined; onColorChange()" *ngIf="!disabled" class="pi pi-times cursor-pointer"></i>
  </span>
</div>
